import React from 'react';
import MaterialReceiptsScreen from './screens/MaterialReceiptsScreen';

export default function MaterialReceipts() {
  return <MaterialReceiptsScreen />;
}
